import { render } from "./ReferenceDetails.vue?vue&type=template&id=e36e1180&scoped=true"
import script from "./ReferenceDetails.vue?vue&type=script&lang=js"
export * from "./ReferenceDetails.vue?vue&type=script&lang=js"

import "./ReferenceDetails.vue?vue&type=style&index=0&id=e36e1180&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36e1180"]])

export default __exports__